export const createMarker = (data) => (
  {
    type: "CREATE_MARKER", payload: data
  });

export const setMarkerOpen = (data) => ({ type: "SET_MARKER_OPEN", payload: data });
